import React from 'react';
import { instructionVersionsDataChanged } from '../actions/instuctionActions';
import { connect } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { startFileUploadToNextcloud } from '../actions/nextcloudActions';
import StyledIcon from '../../components/common/StyledIcon';
import { ImageElement } from './OKNOKDropField/DropArea/Atom';
import deleteSection from './DeleteSection';
import { validateAttachmentName } from '../utils';
import {checkIsPDF, getDirectLink} from './utils';

function GeneralPhoto ({generalPhoto, versionIndex, dataIndex, disable, dispatch, lastUsedAttachment}) {
  const instructionVersionsData = (value, field) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...generalPhoto, [field]: value }))};
  const instructionVersionsDataObj = (obj) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...generalPhoto, ...obj }))};
  const synchronizeWithNextcloud = event => dispatch(startFileUploadToNextcloud(event));

  const onDrop = (ev) => {
    if (disable) return;
    //drop from widget
    const url = ev.dataTransfer.getData('Text');
    if(!url) return;
    instructionVersionsDataObj({attachments: [{attachmentUrl: lastUsedAttachment.url, attachmentOriginalName: lastUsedAttachment.fullName.split("/")[2]}]});
  };

  const { getRootProps, getInputProps } = useDropzone({
    disabled: disable,
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      if (disable) return;
      if(!validateAttachmentName(acceptedFiles)) return;
      //get only first file from array of files
      instructionVersionsDataObj({attachments: [{attachmentUrl: URL.createObjectURL(acceptedFiles[0]), attachmentOriginalName: acceptedFiles[0].name}]});
      synchronizeWithNextcloud(acceptedFiles);
    },
  });

  const deleteAttachment = (event) => {
    event.stopPropagation()
    instructionVersionsDataObj({attachments: [{attachmentUrl: "", attachmentOriginalName: ""}]});
  };

  return (
    <div onDrop={(e) => onDrop(e)}>
      <div style={{width: "100%", height: 200, display: "flex"}}{...getRootProps()}>
        <input {...getInputProps()}/>
        {generalPhoto.attachments && !generalPhoto.attachments[0].attachmentUrl && (
          <StyledIcon color="rgba(0,0,0,0.2)" size="ultra" glyph="edit" bsClass="glyphicon glyphicon glyphicon-edit" style={{paddingTop: "35px", marginLeft: "auto", marginRight: "auto"}}/>
        )}
        {!checkIsPDF(generalPhoto.attachments[0]) && generalPhoto.attachments && generalPhoto.attachments[0].attachmentUrl && (
          <div style={{textAlign: "center", width: '100%'}}>
            <ImageElement src={getDirectLink(generalPhoto.attachments[0])} alt={generalPhoto.attachments[0].attachmentOriginalName} style={{marginLeft: "auto", marginRight: "auto"}}/>
          </div>
        )}
        {checkIsPDF(generalPhoto.attachments[0]) && (
          <div style={{marginLeft: "auto", marginRight: "auto"}}>
            <span>{generalPhoto.attachments[0].attachmentOriginalName}</span>
            <a href={generalPhoto.attachments[0].attachmentUrl} download onClick={(event)=>{event.stopPropagation()}} style={{display:"contents"}}>
              <ImageElement
                disabled={checkIsPDF(generalPhoto.attachments[0])}
                src={getDirectLink(generalPhoto.attachments[0])}
                alt={generalPhoto.attachments[0].attachmentOriginalName}
              />
            </a>
          </div>
        )}
        {!disable && generalPhoto.attachments[0].attachmentUrl && (<span
          onClick={(event) => deleteAttachment(event)}
          style={{cursor: "pointer", display: "inline"}}>X</span>
        )}
      </div>
      {!checkIsPDF(generalPhoto.attachments[0]) && generalPhoto.attachments && generalPhoto.attachments[0].attachmentUrl && (
        <span style={{width: '100%', textAlign: "center"}}>
          <a href={getDirectLink(generalPhoto.attachments[0])} target="_blank" style={{display: 'block'}}>Open in new tab!</a>
        </span>
      )}
      <textarea
        disabled={disable}
        style={{ width: "100%", height: 70 }}
        value={generalPhoto.description}
        onChange={(event)=>{instructionVersionsData(event.target.value, "description")}}
      />
    </div>
  )
}

const mapStateToProps = ({ filesWidgetReducer, instructionsReducer }) => {
  return {
    lastUsedAttachment: filesWidgetReducer.lastUsedAttachment,
    versions: instructionsReducer.versions
  }
}

const mapDispatchToProps = (dispatch) => {
  return {dispatch};
}

export default connect(mapStateToProps, mapDispatchToProps)(deleteSection(GeneralPhoto));
